import React, { Fragment, useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router";
import {
  faPlus,
  faSave,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GetStudentService from "../../../../services/SchoolIT/GetStudentService";
import swal from "sweetalert";
import AppHeader from "../../../../Layout/AppHeader";
import AppSidebar from "../../../../Layout/AppSidebar";
import { Modal, ModalBody } from "reactstrap";
import GetAdminService from "../../../../services/admin/GetAdminService";
import CustomLoader from "../../../customLoader/CustomLoader";
import "../StudentProgress.css";

const goalFieldOptionArray = [
  { id: "course", field_name: "completed course requirement" },
  { id: "AND", field_name: "completed all of the following" },
  { id: "OR", field_name: "completed one of the following" },
];

const AddNewModal = ({ isOpen, closeHandler, data }) => {
  const [input, setInput] = useState("");

  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={closeHandler} centered>
        <ModalBody>
          <h5 style={{ padding: "15px 16px 0 16px", textAlign: "center" }}>
            {data.title}
          </h5>
          <div style={{ position: "relative", padding: "10px" }}>
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              style={{ width: "100%", padding: "5px", borderRadius: "5px" }}
              type="text"
              placeholder="Field Name"
              className="require-input-name"
            />
          </div>
        </ModalBody>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "5px 0 30px 0",
          }}
        >
          <button
            disabled={!input}
            style={{ padding: "5px 20px", margin: "0 30px", fontSize: "20px" }}
            className={!input ? "disabled-modal-button" : "save-modal-button"}
            onClick={() => data.save(input)}
          >
            <FontAwesomeIcon icon={faSave} style={{ margin: "0 10px" }} />
            Save
          </button>
          <button
            style={{
              padding: "5px 20px",
              margin: "0 30px",
              fontSize: "20px",
            }}
            className="cancel-modal-button"
            onClick={closeHandler}
          >
            <FontAwesomeIcon icon={faTimes} style={{ margin: "0 6px" }} />
            Cancel
          </button>
        </div>
      </Modal>
    </Fragment>
  );
};

const CreateGoal = () => {
  let history = useHistory();
  let location = useLocation();
  const [parentCount, setParentCount] = useState(0);
  const [parentCountArray, setParentCountArray] = useState([]);
  const [courseCriteria, setCourseCriteria] = useState([]);
  const [goalFieldOption, setGoalFieldOption] = useState([]);

  const [goalName, setGoalName] = useState();
  const [goalDescription, setGoalDescription] = useState();
  const [goalId, setGoalId] = useState(
    location?.pathname?.split("/").pop() === "goal"
      ? ""
      : location?.pathname?.split("/").pop()
  );
  const [goalData, setGoalData] = useState();
  const [addNewCourseModal, setAddNewCourseModal] = useState(false);
  const [addNewGoalModal, setAddNewGoalModal] = useState(false);
  const [marginForParent, setMarginForParent] = useState("");
  const [user, setUser] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [loading, setLoading] = useState(false);
  const [requiredSubGoalData, setRequiredSubGoalData] = useState([]);
  const [selectedGoal, setSelectedGoal] = useState([]);
  const [goalpublishData, setGoalPublishData] = useState([]);
  const [courseListData, setCourseListData] = useState([]);
  const [fieldOperators, setFieldOperators] = useState([]);
  const [addGoalName, setAddGoalName] = useState();
  const haveOrHaveNotRef = useRef();
  const gpaRef = useRef();
  const fieldOptionRef = useRef();
  const courseRef = useRef();
  const arithemeticOperatorRef = useRef();
  const timeout = useRef();
  const addGoalNameRef = useRef();

  const getGoalDetail = () => {
    setLoading(true);
    GetStudentService.getGoalDetail(goalId)
      .then((data) => {
        setLoading(false);
        setGoalData(data?.data);
        if (data?.data?.green) {
          setCourseCriteria(Object.values(data?.data?.green));
        }
        setGoalName(data?.data?.goal_name);
        setGoalDescription(data?.data?.goal_description);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const saveGoalMap = () => {
    if (goalId) {
      for (let i = 0; i < courseCriteria.length; i++) {
        if (courseCriteria[i].simple_exp) {
          courseCriteria[i].green_simple_exp = courseCriteria[i].simple_exp;
          delete courseCriteria[i].simple_exp;
        } else courseCriteria[i].green_simple_exp = "";
      }
    }

    let obj = {
      goal_description: goalDescription,
      goal_name: goalName,
      green: [null, ...courseCriteria],
      // school_id: user?.school_id,
      subgoal_id: requiredSubGoalData,
    };

    if (goalId) {
      obj.goal_id = goalId;
      obj.subgoal_id = Object.values(goalData?.subgoal_id);
    }
    GetStudentService.createGoalMap(obj)
      .then((data) => {
        if (data?.msg) {
          swal({
            text: `Selected Literal goalfield ${data["msg"]}`,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
            },
            closeOnClickOutside: false,
          });
        } else {
          history.push("/admin/ccplus");
        }
      })
      .catch((error) => {
        if (error.response.data) {
          swal({
            text: `The given Goal name already exists`,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
            },
            closeOnClickOutside: false,
          });
        }
      });
  };

  const saveNewCourse = (name) => {
    let obj = {
      name: name,
      school_id: user?.school_id,
    };
    GetStudentService.saveNewCourse(obj)
      .then((data) => {
        setAddNewCourseModal(false);
      })
      .catch((error) => {
        if (error.response.data) {
          swal({
            text: error.response.data.message,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
            },
            closeOnClickOutside: false,
          });
        }
      });
  };
  const saveNewGoalField = (name) => {
    let obj = {
      field_name: name,
      school_id: user?.school_id,
    };
    GetStudentService.saveNewGoalField(obj)
      .then((data) => {
        setAddNewGoalModal(false);
      })
      .catch((error) => {
        if (error.response.data) {
          swal({
            text: error.response.data.message,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
            },
            closeOnClickOutside: false,
          });
        }
      });
  };

  useEffect(() => {
    if (selectedGoal?.length > 0) {
      let array = [];
      selectedGoal.map((item, index) => {
        let obj = {};
        obj["sub_goal"] = item?.goal?.id;
        obj["goal_name"] = item?.goal?.goal_name;
        obj["sub_goal_id"] = item?.goal?.subgoal_id;
        array.push(obj);
      });
      setRequiredSubGoalData(array);
    }
  }, [selectedGoal]);

  useEffect(() => {
    setParentCountArray([...parentCountArray, parentCount + 1]);
  }, [parentCount]);

  useEffect(() => {
    setMarginForParent(40 * parentCountArray.length);
  }, [JSON.stringify(parentCountArray)]);

  const AddNewCriteria = (parentValue) => {
    if (parentValue) {
      setParentCount(parentCount + 1);
    }
    let array = [];
    let data = {
      field_name: "",
      operator: "",
      value: "",
      course_req: "",
      green_simple_exp: "",
      parent: parentValue ? parentCountArray : [],
      level: parentValue ? parentCountArray.length : 0,
      margin: parentValue ? `${marginForParent}px` : "margin",
      have_not: "",
    };
    array.push(data);
    setCourseCriteria([...courseCriteria, ...array]);
  };

  const removeCourseCriteria = (index) => {
    courseCriteria.splice(index, 1);
    setCourseCriteria([...courseCriteria]);
  };

  const getCourseList = () => {
    GetAdminService.listOfCourse("broadcastcourse")
      .then((data) => {
        setCourseListData(data.data.objects);
      })
      .catch((error) => {
      });
  };

  const getFieldOperators = () => {
    GetStudentService.listOfOperators()
      .then((data) => {
        setFieldOperators(data?.data?.objects);
      })
      .catch((error) => {
      });
  };

  const getGoalField = () => {
    GetAdminService.goalFieldForCreateGoal(100)
      .then((data) => {
        setGoalFieldOption([...data?.data?.objects, ...goalFieldOptionArray]);
      })
      .catch((error) => {
      });
  };

  const handleGoalNameChange = () => {
    clearTimeout(timeout.current);
    setAddGoalName(addGoalNameRef.current.value);
    timeout.current = setTimeout(() => {
      getPublishData(addGoalNameRef.current.value);
    }, 1000);
  };

  const getPublishData = (goalName) => {
    GetAdminService.adminGoalSearch(goalName)
      .then((data) => {
        setGoalPublishData(data?.data?.objects);
      })
      .catch((error) => {
      });
  };

  const handlehaveOrHaveNotChange = (index, e) => {
    courseCriteria[index].have_not = e.target.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleFieldOption = (index, e) => {
    // courseCriteria[index].field_name = fieldOptionRef.current.value;
    courseCriteria[index].field_name = e.target.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleCourseChange = (index) => {
    courseCriteria[index].course_req = courseRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleArithemeticOperatorChange = (index) => {
    courseCriteria[index].operator = arithemeticOperatorRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleGPAChange = (index) => {
    courseCriteria[index].value = gpaRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleSelectedGoal = (item) => {
    let array = [];
    array.push(item);
    setSelectedGoal([...selectedGoal, ...array]);
    setGoalPublishData([]);
    addGoalNameRef.current.value = null;
  };

  const removeSelectedGoal = (index) => {
    selectedGoal.splice(index, 1);
    setSelectedGoal([...selectedGoal]);
  };

  useEffect(() => {
    if (goalId) getGoalDetail();
    getCourseList();
    getFieldOperators();
    getGoalField();
  }, []);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          {loading ? (
            <CustomLoader />
          ) : (
            <div className="admin-ccplus-page">
              <div className="admin-ccplus-header">
                <div>
                  <h1 className="admin-ccplus-title">Create New Goal</h1>
                  <p className="admin-ccplus-subtitle">
                    Define goal details and requirement structure
                  </p>
                </div>
                <div className="admin-ccplus-header-actions">
                  <button
                    className="admin-ccplus-btn secondary toolbar"
                    onClick={() => setAddNewCourseModal(true)}
                  >
                    Add New Required Course Set
                  </button>
                  <button
                    onClick={() => setAddNewGoalModal(true)}
                    className="admin-ccplus-btn secondary toolbar"
                  >
                    Add New Goal Field
                  </button>
                  <button
                    onClick={() => history.push("/admin/ccplus")}
                    className="admin-ccplus-btn ghost toolbar"
                  >
                    Back
                  </button>
                </div>
              </div>
              <div className="admin-ccplus-form-card admin-create-goal-form">
                <div className="admin-course-set-field">
                  <label className="admin-course-set-label" htmlFor="goal-name">
                    Goal Name{" "}
                    <span className="admin-course-set-required">*</span>
                  </label>
                  <input
                    id="goal-name"
                    value={goalName || ""}
                    onChange={(e) => setGoalName(e.target.value)}
                    type="text"
                    placeholder="Type a goal name"
                    className="admin-course-set-input"
                  />
                </div>

                <div className="admin-course-set-field">
                  <label
                    className="admin-course-set-label"
                    htmlFor="goal-description"
                  >
                    Goal Description{" "}
                    <span className="admin-course-set-required">*</span>
                  </label>
                  <textarea
                    id="goal-description"
                    value={goalDescription || ""}
                    onChange={(e) => setGoalDescription(e.target.value)}
                    className="admin-course-set-input admin-course-set-textarea"
                    placeholder="Type a goal description"
                    rows="5"
                  />
                </div>

                <div className="admin-course-set-field admin-create-goal-subgoal">
                  <label
                    className="admin-course-set-label"
                    htmlFor="add-goal-name"
                  >
                    Add Related Goal
                    <span className="admin-course-set-optional">
                      {" "}
                      (optional)
                    </span>
                  </label>
                  <div className="admin-create-goal-subgoal-wrap">
                    <input
                      id="add-goal-name"
                      ref={addGoalNameRef}
                      onChange={handleGoalNameChange}
                      type="text"
                      className="admin-course-set-input"
                      placeholder="Type a goal name to add"
                    />
                    {goalpublishData.length > 0 && (
                      <ul className="goal-dropdown-list">
                        {goalpublishData?.map((item, index) => (
                          <li
                            key={item?.id || item?.goal?.id || index}
                            className="goal-dropdown-item"
                            onClick={() => handleSelectedGoal(item)}
                          >
                            {item?.goal_name || item?.goal?.goal_name}
                          </li>
                        ))}
                      </ul>
                    )}
                    {selectedGoal?.length > 0 && (
                      <div className="admin-create-goal-chips">
                        {selectedGoal?.map((item, index) => (
                          <div
                            key={item?.id || item?.goal?.id || index}
                            className="admin-create-goal-chip"
                          >
                            {item?.goal_name || item?.goal?.goal_name}
                            <FontAwesomeIcon
                              onClick={() => removeSelectedGoal(index)}
                              icon={faTimes}
                              className="admin-create-goal-chip-remove"
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="admin-create-goal-criteria">
                  <div className="admin-create-goal-criteria-header">
                    Create a set of criteria for green
                  </div>

                  {courseCriteria?.length > 0 &&
                    courseCriteria?.map((item, index) => (
                      <div
                        key={`criteria-${index}`}
                        className="admin-create-goal-criteria-block"
                      >
                        <div
                          className="admin-create-goal-criteria-row"
                          style={{
                            marginLeft: item.level > 0 ? "48px" : "0",
                          }}
                        >
                          <button
                            type="button"
                            onClick={() => removeCourseCriteria(index)}
                            className="admin-create-goal-remove-btn"
                          >
                            <FontAwesomeIcon icon={faTimes} />
                          </button>
                          <span className="admin-create-goal-criteria-label">
                            Student must
                          </span>
                          <select
                            value={item?.have_not || ""}
                            onChange={(e) =>
                              handlehaveOrHaveNotChange(index, e)
                            }
                            className="admin-create-goal-select"
                          >
                            <option value="" disabled>
                              --Select option---
                            </option>
                            <option value="True">have</option>
                            <option value="False">have not </option>
                          </select>
                          <select
                            ref={fieldOptionRef}
                            value={item?.field_name || ""}
                            onChange={(e) => handleFieldOption(index, e)}
                            className="admin-create-goal-select admin-create-goal-select--wide"
                          >
                            <option disabled value="">
                              --Select--
                            </option>
                            {goalFieldOption?.map((fieldItem, fieldIndex) => (
                              <option
                                key={fieldItem?.id || fieldIndex}
                                value={fieldItem?.id}
                              >
                                {fieldItem?.field_name}
                              </option>
                            ))}
                          </select>
                          {!(
                            item.field_name === "AND" ||
                            item.field_name === "OR" ||
                            item.field_name === "course" ||
                            item.field_name === ""
                          ) && (
                            <div className="admin-create-goal-inline-group">
                              <select
                                value={item?.operator || ""}
                                ref={arithemeticOperatorRef}
                                onChange={() =>
                                  handleArithemeticOperatorChange(index)
                                }
                                className="admin-create-goal-select"
                              >
                                <option disabled value="">
                                  --Select Operator--
                                </option>
                                {fieldOperators?.map((opItem, opIndex) => (
                                  <option
                                    key={opItem?.id || opIndex}
                                    value={parseInt(opItem?.id)}
                                  >
                                    {opItem?.operator}
                                  </option>
                                ))}
                              </select>
                              <input
                                type="text"
                                ref={gpaRef}
                                value={item?.value || ""}
                                onChange={() => handleGPAChange(index)}
                                className="admin-create-goal-value-input"
                              />
                            </div>
                          )}
                          {item.field_name === "course" && (
                            <select
                              ref={courseRef}
                              value={item?.course_req || ""}
                              onChange={() => handleCourseChange(index)}
                              className="admin-create-goal-select admin-create-goal-select--wide"
                            >
                              <option value="">--Select Course--</option>
                              {courseListData?.map((courseItem, courseIndex) => (
                                <option
                                  key={courseItem?.course?.id || courseIndex}
                                  value={courseItem?.course?.id}
                                >
                                  {courseItem?.course?.name}
                                </option>
                              ))}
                            </select>
                          )}
                        </div>
                        {(item.field_name === "AND" ||
                          item.field_name === "OR") && (
                          <div className="admin-create-goal-subcriteria">
                            <button
                              type="button"
                              className="admin-ccplus-btn secondary toolbar"
                              onClick={() => AddNewCriteria(true)}
                            >
                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                            <p className="no-margin-bottom">
                              <b>Add additional sub-criteria</b>
                            </p>
                          </div>
                        )}
                      </div>
                    ))}

                  <div className="admin-create-goal-add-criteria">
                    <button
                      type="button"
                      className="admin-ccplus-btn secondary"
                      onClick={() => AddNewCriteria(false)}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                      Add additional Criteria
                    </button>
                  </div>
                </div>

                <div className="admin-ccplus-form-actions">
                  <button
                    type="button"
                    disabled={!(goalName && goalDescription)}
                    className={`admin-ccplus-btn primary ${
                      !(goalName && goalDescription) ? "is-disabled" : ""
                    }`}
                    onClick={saveGoalMap}
                  >
                    <FontAwesomeIcon icon={faSave} />
                    Save
                  </button>

                  <button
                    type="button"
                    className="admin-ccplus-btn ghost"
                    onClick={() => history.push("/admin/ccplus")}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                    Cancel
                  </button>
                </div>

              {addNewCourseModal && (
                <AddNewModal
                  isOpen={addNewCourseModal}
                  closeHandler={() => {
                    setAddNewCourseModal(false);
                  }}
                  data={{
                    title: "Create Required Course Set",
                    save: saveNewCourse,
                  }}
                />
              )}

              {addNewGoalModal && (
                <AddNewModal
                  isOpen={addNewGoalModal}
                  closeHandler={() => {
                    setAddNewGoalModal(false);
                  }}
                  data={{ title: "New Goal Field", save: saveNewGoalField }}
                />
              )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};
export default CreateGoal;
